import { FC, PropsWithChildren } from 'react';
import { IconDataAdornments, IconDataAdornmentsProps } from '.';
import { StyledAdornmentWrapper } from './styles';

export const WithIconDataAdornments: FC<
  PropsWithChildren<
    IconDataAdornmentsProps & {
      wrapperTranslateYValue?: string;
      hasAdornments: boolean;
    }
  >
> = ({
  wrapperTranslateYValue,
  hasAdornments,
  children,
  adornments,
  ...props
}) => {
  return hasAdornments && adornments.length > 0 ? (
    <StyledAdornmentWrapper translateYValue={wrapperTranslateYValue}>
      {children}
      <IconDataAdornments adornments={adornments} {...props} />
    </StyledAdornmentWrapper>
  ) : (
    <>{children}</>
  );
};
